<div
  *ngIf="visible"
  class="vc-mobile-appt-sheet"
  role="dialog"
  aria-modal="true"
  aria-labelledby="vc-mobile-appt-sheet-title"
>
  <p-confirmDialog styleClass="vc-mobile-appt-sheet__confirm"></p-confirmDialog>

  <button
    type="button"
    class="vc-mobile-appt-sheet__backdrop"
    aria-label="Close"
    (click)="close()"
  ></button>

  <section class="vc-mobile-appt-sheet__panel">
    <header class="vc-mobile-appt-sheet__header">
      <div class="vc-mobile-appt-sheet__grabber"></div>
      <div class="vc-mobile-appt-sheet__header-row">
        <button
          pButton
          type="button"
          class="p-button-text"
          [label]="'COMMON.CANCEL' | translate"
          (click)="close()"
        ></button>

        <h2 id="vc-mobile-appt-sheet-title">
          {{
            isEditing
              ? ("APPOINTMENT.MOBILE.DRAWER.EDIT_TITLE" | translate)
              : ("APPOINTMENT.MOBILE.DRAWER.TITLE" | translate)
          }}
        </h2>

        <button
          pButton
          type="button"
          [label]="'COMMON.SAVE' | translate"
          [disabled]="!canSave"
          [loading]="saving"
          (click)="save()"
        ></button>
      </div>
    </header>

    <div class="vc-mobile-appt-sheet__content">
      <div class="vc-mobile-appt-drawer__summary">
        <div>
          <span class="vc-mobile-appt-drawer__label">{{
            "APPOINTMENT.MOBILE.DRAWER.START" | translate
          }}</span>
          <input
            type="datetime-local"
            class="vc-mobile-appt-sheet__input"
            [ngModel]="startInputValue"
            (ngModelChange)="onStartChanged($event)"
          />
        </div>

        <div>
          <span class="vc-mobile-appt-drawer__label">{{
            "APPOINTMENT.MOBILE.DRAWER.END" | translate
          }}</span>
          <input
            type="datetime-local"
            class="vc-mobile-appt-sheet__input"
            [ngModel]="endInputValue"
            (ngModelChange)="onEndChanged($event)"
          />
        </div>
      </div>

      <div class="vc-mobile-appt-drawer__field" *ngIf="calendarOptions.length > 1">
        <label>{{ "COMMON.CALENDAR" | translate }}</label>
        <select
          class="vc-mobile-appt-sheet__input"
          [ngModel]="draft.calendar?.id"
          (ngModelChange)="onCalendarChange($event)"
        >
          <option
            *ngFor="let option of calendarOptions"
            [ngValue]="option.id"
          >
            {{ option.name }}
          </option>
        </select>
      </div>

      <div class="vc-mobile-appt-drawer__field">
        <label>{{ "APPOINTMENT.MOBILE.DRAWER.TITLE_LABEL" | translate }}</label>
        <input
          type="text"
          class="vc-mobile-appt-sheet__input"
          [ngModel]="draft.title"
          (ngModelChange)="draft.title = $event"
          maxlength="120"
        />
      </div>

      <div class="vc-mobile-appt-drawer__field">
        <label>{{ "APPOINTMENT.MOBILE.DRAWER.PATIENT_LABEL" | translate }}</label>

        <div
          *ngIf="draft.patient?.id; else patientSearchControl"
          class="vc-mobile-appt-sheet__selected-row"
        >
          <span>{{ selectedPatientLabel }}</span>
          <button type="button" (click)="clearPatientSelection()">
            {{ "COMMON.CLEAR" | translate }}
          </button>
        </div>

        <ng-template #patientSearchControl>
        <input
          type="search"
          class="vc-mobile-appt-sheet__input"
          autocomplete="off"
          [ngModel]="patientQuery"
          (ngModelChange)="onPatientQueryChange($event)"
          [placeholder]="
            'APPOINTMENT.MOBILE.DRAWER.PATIENT_PLACEHOLDER' | translate
          "
        />

        <div
          *ngIf="patientSearchLoading"
          class="vc-mobile-appt-sheet__helper"
        >
          {{ "COMMON.LOADING" | translate }}...
        </div>

        <div
          *ngIf="
            !patientSearchLoading &&
            patientSuggestions.length
          "
          class="vc-mobile-appt-sheet__suggestions vc-mobile-appt-sheet__patient-suggestions"
        >
          <button
            type="button"
            *ngFor="let patient of patientSuggestions"
            (click)="onPatientSelected(patient)"
          >
            <span>{{ patient.identifier }}</span>
            <small *ngIf="patient.phone">{{ patient.phone }}</small>
          </button>
        </div>

        <div
          *ngIf="
            !patientSearchLoading &&
            !draft.patient?.id &&
            patientQuery &&
            patientQuery.length >= 2 &&
            !patientSuggestions.length
          "
          class="vc-mobile-appt-sheet__helper"
        >
          {{ "APPOINTMENT.MOBILE.DRAWER.PATIENT_EMPTY" | translate }}
        </div>

        <div class="vc-mobile-appt-sheet__sr-only" aria-live="polite">
          {{ patientSuggestions.length }}
        </div>
        </ng-template>
      </div>

      <div class="vc-mobile-appt-drawer__field">
        <label>{{ "APPOINTMENT.MOBILE.DRAWER.TREATMENTS_LABEL" | translate }}</label>

        <div
          *ngIf="!draft.patient?.id"
          class="vc-mobile-appt-sheet__helper"
        >
          {{ "APPOINTMENT.MOBILE.DRAWER.TREATMENTS_HINT" | translate }}
        </div>

        <div
          *ngIf="draft.patient?.id && treatmentOptionsLoading"
          class="vc-mobile-appt-sheet__helper"
        >
          {{ "COMMON.LOADING" | translate }}...
        </div>

        <div
          *ngIf="draft.patient?.id && !treatmentOptionsLoading"
          class="vc-mobile-appt-sheet__details"
        >
          <div
            *ngIf="selectedTreatmentLabel; else treatmentPicker"
            class="vc-mobile-appt-sheet__selected-row"
          >
            <span>{{ selectedTreatmentLabel }}</span>
            <button type="button" (click)="clearTreatmentSelection()">
              {{ "COMMON.CLEAR" | translate }}
            </button>
          </div>

          <ng-template #treatmentPicker>
          <div
            *ngIf="availablePatientTreatments.length"
            class="vc-mobile-appt-sheet__treatment-group"
          >
            <strong>{{
              "APPOINTMENT.MOBILE.DRAWER.AVAILABLE_TREATMENTS" | translate
            }}</strong>
            <div class="vc-mobile-appt-sheet__suggestions">
              <button
                type="button"
                *ngFor="let treatment of availablePatientTreatments"
                [class.is-selected]="selectedExistingTreatmentId === treatment.id"
                (click)="selectExistingTreatment(treatment.id)"
              >
                {{ treatment.treatment?.name || ("COMMON.NO_NAME" | translate) }}
              </button>
            </div>
          </div>

          <div class="vc-mobile-appt-sheet__treatment-group">
            <strong>{{
              "APPOINTMENT.MOBILE.DRAWER.CATALOG_TREATMENTS" | translate
            }}</strong>
            <select
              class="vc-mobile-appt-sheet__input"
              [ngModel]="selectedCatalogTreatmentId"
              (ngModelChange)="selectCatalogTreatment($event)"
            >
              <option [ngValue]="null">
                {{ "APPOINTMENT.MOBILE.DRAWER.CATALOG_PLACEHOLDER" | translate }}
              </option>
              <option
                *ngFor="let treatment of catalogTreatments"
                [ngValue]="treatment.id"
              >
                {{ treatment.name }}
              </option>
            </select>
          </div>
          </ng-template>
        </div>
      </div>

      <div class="vc-mobile-appt-drawer__field">
        <label>{{ "APPOINTMENT.MOBILE.DRAWER.NOTES_LABEL" | translate }}</label>
        <textarea
          pTextarea
          [ngModel]="draft.notes"
          (ngModelChange)="draft.notes = $event"
          rows="3"
          autoResize="autoResize"
        ></textarea>
      </div>

      <div class="vc-mobile-appt-drawer__conflicts" *ngIf="conflicts.length">
        <strong>{{ "APPOINTMENT.MOBILE.CONFLICTS.TITLE" | translate }}</strong>
        <ul>
          <li *ngFor="let conflict of conflicts">
            {{ conflict.start | date: "dd/MM HH:mm" }} -
            {{ conflict.end | date: "HH:mm" }} ·
            {{ conflict.name || ("APPOINTMENT.TITLE" | translate) }}
          </li>
        </ul>
      </div>

      <button
        *ngIf="isEditing"
        pButton
        type="button"
        class="p-button-danger p-button-outlined vc-mobile-appt-sheet__delete"
        [label]="'COMMON.DELETE' | translate"
        [disabled]="saving"
        (click)="confirmDeleteAppointment()"
      ></button>
    </div>
  </section>
</div>
